import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { AppRouter } from '@/routes';
import { useVisitorStore } from '@/stores/visitorStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function VisitorInit() {
  const init = useVisitorStore((s) => s.init);

  useEffect(() => {
    init();
  }, [init]);

  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <VisitorInit />
      <AppRouter />
    </QueryClientProvider>
  );
}
